import { getSelectedProject, hasSelectedProject } from 'owa-timestream-store';
import { default as getDefaultBoardProject } from './getDefaultBoardProject';
import { switchToBoardText } from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import loc from 'owa-localize';

export default function getSelectedBoardProjectName(): string {
    const selectedProject = hasSelectedProject() ? getSelectedProject() : undefined;
    const defaultBoardProject = getDefaultBoardProject();
    return selectedProject?.projectId == defaultBoardProject?.projectId
        ? loc(switchToBoardText)
        : selectedProject
        ? selectedProject.name
        : loc(switchToBoardText);
}
